import { SafeUrl } from '@angular/platform-browser';

export class EmailDialogModel {
    htmlContentSrc: SafeUrl;
    sender: String;
    subject: String;
}
